import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class BaReviewService {

  constructor(private rest : RestService) { }

  public bareviewPresentInProjectForArtifacts(data : any , data1 : any, page: number = 0){

    let payload = {
      "artifactType":data,
      "projectId": data1,
      "page": page.toString(),
      "size":"10"
  }
    return this.rest.post('getProjectArtifactsHaveBaReviews',payload , null);
  }

  public reviewCommentAndRepliesOnArtifact(artifactId : any){
    return this.rest.get("reviewCommentAndRepliesOnArtifact", artifactId);
  }

  public resolveReview(reviewId : string ,sendMail :boolean ){
    return this.rest.get("resolveReview", reviewId , sendMail);
  }

  public editReview(reviewId :string,editedComment : any){
    let payload ={
       "reviewId":reviewId,
       "editedReview":editedComment
    }
    console.log(payload);
    return this.rest.post('editReview', payload ,null);
  }

  public editReply(reviewId : string , replyId:string , editedReply :string ){
    let payload ={
      "reviewId":reviewId,
      "replyId":replyId,
      "updatedReply":editedReply
    }
    console.log(payload);
    return this.rest.put('editReply', payload);
  }

   public addReplyCommentToReview(payload :any){
    console.log('new reply comment',payload);
    return this.rest.post('newReplyComment', payload , null);
   }

   public deleteReview(reviewId :string) : any{
    return this.rest.delete('deleteBaReviewByReviewId', reviewId);
   }
   public deleteReply(reviewId :string , replyId :string){
    return this.rest.delete('deleteBaReviewReplyByReviewReplyId', reviewId, replyId);
   }

   public getArtifactListPresentInExecution(executionId :string , artifactType : string){
    let payload ={
      "artifactType":artifactType,
      "executionId" : executionId,
      "page":"0",
      "size":"10"
    }
    return this.rest.post('getArtifactsByExecutionId' , payload , null);
   }

   public isUserBA() {
    return this.rest.get('isUserBA', null, null);
   }

   public submitBusinessReview(executionId :string ,artifactType:string , artifactId :string , artifactName :string , reviewComment : string){
    
    console.log('executionId : ',executionId ,'artifact type :', artifactId, 'artifactId :',artifactId , 'artifactName : ',artifactName ,'comment : ',reviewComment);
    let payload = {
      "artifact_type":artifactType,
      "artifact_id":artifactId,
      "artifact_name":artifactName,
      "review_comment":reviewComment,
      "execution_id":executionId
    }

    console.log('payload to add the review on artifact'  , payload);
     return this.rest.post('addReviewComment' , payload , null);
   }

   public reportReviews(executionId ){
    console.log('executionID' , executionId);
    return this.rest.get('getReviewsOfReport',executionId)
   }
}
